import globalEventBus from 'toxilibs/event_bus_queued.js'
import World from './world_core/world.js'
import './game_rules.js'

let currentWorld

globalEventBus.on('challenge loaded', function (challenge) {
    destroyWorld()

    currentWorld = new World(globalEventBus('world'), challenge)
})


globalEventBus.on('chef wants to quit game', destroyWorld)


function destroyWorld () {
    if (currentWorld) {
        currentWorld.destroy()
        currentWorld = null
    }
}


